package kz.dentalcrm.app.screens.login.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface LoginViewEvent : ViewEvent {
    data class Login(val email: String, val password: String) : LoginViewEvent
    data object ResetError : LoginViewEvent
}
